import { useState } from 'react';
import './SiteUnitCommandsPopup.scoped.scss';
import Input from '@components/_elements/Input/Input';
import Button from '@components/_elements/Button/Button';
import storeConnector from '@store/storeConnector';
import { tsDueTimeMode } from '@utils/index_ts';
import useGetDeviceControlLockMode from '@hooks/api/queries/useGetDeviceControlLockMode';

const ControlUnlockForm = ({
  deviceId,
  timeMode,
  siteMeta,
  setOverInput,
  controllerUnlockNotes,
  setControllerUnlockNotes,
  setControllerUnlockConfirm,
}) => {
  const [controllerUnlockActive, setControllerUnlockActive] = useState(false);
  const { data: controlLockModeRecord } = useGetDeviceControlLockMode(deviceId);

  const getCurrentTime = (ts) => {
    return tsDueTimeMode({
      timeMode,
      lat: siteMeta.GPSLat,
      long: siteMeta.GPSLong,
      ts,
    });
  };

  return (
    <div className='release-container'>
      {!controllerUnlockActive ? (
        <Button onClick={() => setControllerUnlockActive(true)}>
          Unlock Controller
        </Button>
      ) : (
        <>
          <div className='loto-release-title'>Unlock Controller</div>
          <div className='loto-release-info'>
            <div>Lockout Start:</div>
            <div>
              {controlLockModeRecord.createdAt
                ? getCurrentTime(controlLockModeRecord.createdAt)
                : ''}
            </div>
          </div>
          <div className='loto-release-info'>
            <div>Operator:</div>
            <div>{controlLockModeRecord.updatedBy}</div>
          </div>
          <div className='loto-release-info'>
            <div>Notes:</div>
            <div>{controlLockModeRecord.note}</div>
          </div>
          <div className='loto-release-info'>
            <div>Release Notes:</div>
            <Input
              type='text'
              onMouseEnter={() => setOverInput(true)}
              onMouseLeave={() => setOverInput(false)}
              onChange={(val) => setControllerUnlockNotes(val)}
              value={controllerUnlockNotes}
              placeholder={'Enter reason'}
            />
          </div>
          <div
            className='popup-row commands-popup-control'
            style={{ marginTop: '50px' }}
          >
            <Button
              disabled={!controllerUnlockNotes}
              onClick={() => setControllerUnlockConfirm(true)}
            >
              UNLOCK CONTROLLER
            </Button>
            <Button size='m' onClick={() => setControllerUnlockActive(false)}>
              CANCEL
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default storeConnector(ControlUnlockForm, {
  service: ['timeMode'],
  config: ['siteMeta'],
});
